import { render, staticRenderFns } from "./OldLMSData.vue?vue&type=template&id=c9306b14&scoped=true"
import script from "./OldLMSData.vue?vue&type=script&lang=ts"
export * from "./OldLMSData.vue?vue&type=script&lang=ts"
import style0 from "./OldLMSData.vue?vue&type=style&index=0&id=c9306b14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9306b14",
  null
  
)

export default component.exports